import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SettingComponent } from './components/setting/setting.component';
import { AccountComponent } from './components/account/account.component';
import { OrderBlockedComponent } from './components/order-blocked/order-blocked.component';
import { AuthenticationComponent } from './components/authentication/authentication.component';
import { CreditCardPaymentComponent } from './components/credit-card-payment/credit-card-payment.component';
import { DebitCardPaymentComponent } from './components/debit-card-payment/debit-card-payment.component';
import { PixPaymentComponent } from './components/pix-payment/pix-payment.component';
import { HomeComponent } from './components/home/home.component';
import { OrderServiceComponent } from './components/order-service/order-service.component';
import { OrderTrackingComponent } from './components/order-tracking/order-tracking.component';
import { RedirectComponent } from './components/redirect/redirect.component';

export const ROUTES: Routes = [
  { path: '', component: HomeComponent, pathMatch: 'full' },
  { path: 'pix-payment', component: PixPaymentComponent },
  { path: 'debit-card-payment', component: DebitCardPaymentComponent },
  { path: 'credit-card-payment', component: CreditCardPaymentComponent },
  { path: 'order-tracking', component: OrderTrackingComponent },
  { path: 'order-service', component: OrderServiceComponent },
  { path: 'authentication', component: AuthenticationComponent },
  { path: 'config-setting', component: SettingComponent },
  { path: 'pg-account', component: AccountComponent },
  { path: 'order-blocked', component: OrderBlockedComponent },
  { path: 'redirect', component: RedirectComponent },
  { path: 'manager-home', loadChildren: () => import('./modules/manager-home/manager-home.module').then(m => m.ManagerHomeModule) },
  { path: 'manager-notification', loadChildren: () => import('./modules/manager-notification/manager-notification.module').then(m => m.ManagerNotificationModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(ROUTES, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})

export class AppRoutingModule { }

